import gql from 'graphql-tag';

export const DeleteIncidentIssueDocument = gql`
  mutation DeleteIncidentIssueDocumentBulk($input: DeleteIncidentIssueDocumentBulkInput!) {
    deleteIncidentIssueDocumentBulk(input: $input) {
      deleted
    }
  }
`;
